<template>
  <v-layout class="video" ref="videoDiv">
    <videoPlayer
      class="video-player-box"
      ref="videoPlayer"
      :options="playerOptions"
    />
  </v-layout>
</template>

<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";

export default {
  components: {
    videoPlayer,
  },

  data() {
    return {
      playerOptions: {
        height: window.innerHeight,
        width: window.innerWidth,
        autoplay: true,
        language: "en",
        sources: [
          {
            type: `video/${this.$route.query.url.substring(
              this.$route.query.url.lastIndexOf(".") + 1
            )}`,
            src: this.$route.query.url,
          },
        ],
      },
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
    this.$nextTick(() => {
      setTimeout(() => {
        this.onResize();
      }, 250);
    });
  },

  methods: {
    onResize() {
      this.playerOptions.height = this.getHeight();
      this.playerOptions.width = this.getWidth();
    },
    getHeight() {
      return this.$refs.videoDiv.clientHeight;
    },
    getWidth() {
      return this.$refs.videoDiv.clientWidth;
    },
  },
};
</script>

<style scoped>
.video {
  position: absolute;
  width: 100%;
  top: 48px;
  bottom: 1px;
  left: 0;
  right: 0;
  background: #525f69;
}
</style>